export const MAX_CUSTOM_PROMPT_CHARS = 4000;

export const isCustomGenerationType = (type?: string): boolean => type?.split('_')[0] === '커스텀';

export function customGenerationError(types: Iterable<string>, options?: Record<string, unknown>): string | null {
  if (!Array.from(types).includes('커스텀')) return null;
  if (typeof options?.custom_prompt !== 'string' || !options.custom_prompt.trim()) return '커스텀 옵션에서 프롬프트를 입력해주세요.';
  if (options.custom_prompt.length > MAX_CUSTOM_PROMPT_CHARS) return '커스텀 프롬프트는 4,000자 이내로 입력해주세요.';
  if (!['OPENAI', 'CLAUDE', 'GOOGLE'].includes(String(options.custom_ai ?? 'OPENAI'))) return '커스텀 모델을 다시 선택해주세요.';
  return null;
}

export function customGenerationFields(sheetType: string, options?: Record<string, unknown>) {
  if (!isCustomGenerationType(sheetType)) return {};
  const error = customGenerationError(['커스텀'], options);
  if (error) throw new Error(error);
  return { custom_prompt: String(options!.custom_prompt), ai: String(options!.custom_ai ?? 'OPENAI') };
}
